const BaseUrl = () => {
    // return "http://localhost:3001/serendipity-web/"
    return "https://live.bsi.one/serendipity-web/";
    
};  
// export const RedirectUrl = "https://live.bsi.one/serendipity-web";

// export const BaseUrlFE = "http://localhost:5000";
export default BaseUrl;